<div class="modal-header">
  <h4 class="modal-title">
    @if (paymentMethod) {
      Editar método de pago — {{ paymentMethod.name }}
    }

    @if (!paymentMethod) {
      Nuevo método de pago
    }
  </h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')">
  </button>
</div>
<div class="modal-body">
  @if (!loading) {
    <form
      id="formPaymentMethod"
      [formGroup]="form"
      (ngSubmit)="onSubmit()">
      <div class="container-fluid">
        <div class="row">

          <div class="col-12 form-group mb-4">
            <label
              for="code"
              class="form-label">
              Código
            </label>
            <input
              type="text"
              class="form-control"
              formControlName="code"
              placeholder="Ej: credit"
              [ngClass]="{
                'is-invalid': submitted && f['code'].errors
              }">
            @if (submitted && f['code'].errors) {
              <div class="invalid-feedback">
                @if (f['code'].errors!['required']) {
                  <div>Por favor, ingrese el código</div>
                }
              </div>
            }
          </div>

          <div class="col-12 form-group mb-4">
            <label
              for="name"
              class="form-label">
              Nombre
            </label>
            <input
              type="text"
              class="form-control"
              formControlName="name"
              placeholder="Ej: Crédito"
              [ngClass]="{
                'is-invalid': submitted && f['name'].errors
              }">
            @if (submitted && f['name'].errors) {
              <div class="invalid-feedback">
                @if (f['name'].errors!['required']) {
                  <div>Por favor, ingrese el nombre</div>
                }
              </div>
            }
          </div>

        </div>
      </div>
    </form>
  }
</div>
<div class="modal-footer">
  <div class="col-12 my-3">
    <button
      (click)="activeModal.close()"
      type="button"
      class="btn btn-outline-danger w-100">
      Cancelar
    </button>
  </div>
  <div class="col-12">
    <button
      type="submit"
      form="formPaymentMethod"
      class="btn btn-primary w-100">
      {{ paymentMethod ? 'Actualizar' : 'Registrar' }}
    </button>
  </div>
</div>
